qaPresenter.directive('qaCover', [
    '$interval',
    'logService',
    'contentService',
    'helperService',
    'meetingService',
    'attendeeService',
    'connectivityService',
    'vertoService',
    function (
        $interval,
        logService,
        contentService,
        helperService,
        meetingService,
        attendeeService,
        connectivityService,
        vertoService
    ) {
        return {
            restrict: 'E',
            scope: {
                videoFeedCount: '&videoFeedCount'
            },
            link: function (scope, element, attrs, ngCtrl) {
                var videoFeedCover = element.find('#videoFeedCover.qa'); //Matches resolution of video feed (including black background space)
                var coverContainer = element.find('#qaCoverContainer'); //Matches resolution of feed, excluding black background space
                var cover = element.find('#qaCover'); //Matches resolution of screenshare, excluding attendee feeds at the top
                var qaTopic = element.find('.qaTopic');

                var videoFeed;
                var usesAttendeeWebinarViewer;

                if (meetingService.isWebinar()) {
                    if (attendeeService.getIsPresenter() || vertoService.useEdgeServer()) {
                        videoFeed = angular.element('#videoFeed');
                    } else if (helperService.isMobile()) {
                        videoFeed = angular.element('#videoFeed');
                    } else {
                        usesAttendeeWebinarViewer = true;
                    }
                } else {
                    videoFeed = angular.element('#videoFeed');
                }

                var oldDimensions;
                var oldFeedCount = scope.videoFeedCount();
                var oldMaximizedStatus = contentService.isContentMaximized();

                //Watch for changes on window resize
                var dimensionsInterval = $interval(function () {
                    if (!videoFeed[0]) {
                        return;
                    }

                    var changeDetected;

                    //Feed Count
                    var newFeedCount = scope.videoFeedCount();

                    if (oldFeedCount !== newFeedCount) {
                        oldFeedCount = newFeedCount;
                        changeDetected = true;
                    }

                    //Content Maximized
                    var newMaximizedStatus = contentService.isContentMaximized();

                    if (oldMaximizedStatus !== newMaximizedStatus) {
                        oldMaximizedStatus = newMaximizedStatus;
                        changeDetected = true;
                    }

                    //Dimensions
                    var feedCoverWidth = videoFeed[0].offsetWidth;
                    var feedCoverHeight = videoFeed[0].offsetHeight;

                    var newDimensions = feedCoverWidth + 'x' + feedCoverHeight;

                    if (oldDimensions !== newDimensions) {
                        oldDimensions = newDimensions;
                        changeDetected = true;
                    }

                    //Update cover resolution
                    if (changeDetected) {
                        var res = [1280, 720];
                        var ratio = res[0] / res[1];

                        var containedWidthOfVideo;
                        var containedHeightOfVideo;

                        if (feedCoverWidth / feedCoverHeight < ratio) {
                            containedWidthOfVideo = feedCoverWidth;
                            containedHeightOfVideo = feedCoverWidth / ratio;
                        } else {
                            containedHeightOfVideo = feedCoverHeight;
                            containedWidthOfVideo = feedCoverHeight * ratio;
                        }

                        //If webcams are on, offset the cover
                        var topOffset;
                        var percentage;
                        if (newFeedCount > 0) {
                            if (newFeedCount <= 6) {
                                // Less than six feeds
                                percentage = 72 / 360; // 20%
                            } else {
                                // Greater than 6 feeds
                                percentage = 44 / 360; // 11.94444444444444%
                            }

                            topOffset = containedHeightOfVideo * percentage;

                            cover.css('top', topOffset + 'px');
                            cover.addClass('top-offset');
                            qaTopic.addClass('top-offset');

                            if (newFeedCount <= 6) {
                                cover.css('bottom', '0px');
                                cover.removeClass('bottom-offset');
                                qaTopic.removeClass('bottom-offset');
                            } else {
                                // Set bottom offset which is the same as the calculated topOffset.
                                cover.css('bottom', topOffset + 'px');
                                cover.addClass('bottom-offset');
                                qaTopic.addClass('bottom-offset');
                            }
                        } else {
                            if (cover.css('top') !== '0px') {
                                cover.css('top', '0px');
                                cover.removeClass('top-offset');
                                qaTopic.removeClass('top-offset');
                            }

                            if (cover.css('bottom') !== '0px') {
                                cover.css('bottom', '0px');
                                cover.removeClass('bottom-offset');
                                qaTopic.removeClass('bottom-offset');
                            }
                        }

                        //When width is small enough,
                        //cover the video feeds to allow more space for qa data
                        var widthToIgnoreFeeds = topOffset ? 867 : 767;

                        if (containedWidthOfVideo <= widthToIgnoreFeeds) {
                            coverContainer.height(feedCoverHeight);
                            coverContainer.width(containedWidthOfVideo);

                            cover.css('top', '0px');
                            cover.removeClass('top-offset');
                            qaTopic.removeClass('top-offset');

                            cover.css('bottom', '0px');
                            cover.removeClass('bottom-offset');
                            qaTopic.removeClass('bottom-offset');
                        } else {
                            coverContainer.height(containedHeightOfVideo);
                            coverContainer.width(containedWidthOfVideo);
                        }

                        applyCSSClasses(coverContainer, topOffset);

                        videoFeedCover.width(feedCoverWidth);
                        videoFeedCover.height(feedCoverHeight);
                    }
                }, 100);

                scope.$on('$destroy', function () {
                    logService.log('qaCover removed. Stopping dimensionsInterval...');
                    $interval.cancel(dimensionsInterval);
                });

                //Helper Function
                //Applies CSS classes for responsive styling
                function applyCSSClasses(element, topOffset) {
                    var width = element.width();
                    var height = element.height();

                    var xlWidth = topOffset ? 1400 : 1200;
                    var lgWidth = topOffset ? 1192 : 992;
                    var mdWidth = topOffset ? 975 : 775;
                    var smWidth = topOffset ? 867 : 667;

                    element.removeClass();

                    if (width > xlWidth) {
                        element.addClass('xl-width');
                    } else if (width > lgWidth) {
                        element.addClass('lg-width');
                    } else if (width > mdWidth) {
                        element.addClass('md-width');
                    } else if (width > smWidth) {
                        element.addClass('sm-width');
                    } else {
                        element.addClass('xs-width');
                    }
                }
            }
        };
    }
]);
